import { render } from "./PlayerRegisterInfoModal.vue?vue&type=template&id=3a2b79e6"
import script from "./PlayerRegisterInfoModal.vue?vue&type=script&lang=js"
export * from "./PlayerRegisterInfoModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__